import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { TNW_SwitchInspectionReportSchema } from "./TNW_SwitchInspectionReportSchema";
import { TNW_SwitchInspectionReportSchemaV1 } from "./TNW_SwitchInspectionReportSchemaV1";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { SignatureImage } from "../../utils/SignatureImage";
import reportByVersion from "../../utils/reportVersions";

export const TNW_SwitchInspectionReportView = (props) => {
  let { reportData, signatureImage } = props;
  let rowsData = reportData && reportData.assets && Array.isArray(reportData.assets) ? reportData.assets : [];
  let { isPreview } = props;
  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="DETAILED SWITCH INSPECTION REPORT" {...props} centerTitle={true} />
      <ReportInfoSection
        rows={[
          {
            col1: {
              title: "Location",
              value: reportData.location,
            },
            col2: {
              title: "Date",
              value: dataFormatters.dateFormatter(reportData.date),
            },
          },
          {
            col1: {
              title: "Track Inspector",
              value: reportData.user.name,
            },
            col2: {
              title: "Signature",
              value: <SignatureImage placement={"tableCell"} signatureImage={signatureImage} />,
            },
          },
        ]}
      />

      <span className="spacer"></span>
      <table className="table-bordered">
        {TNW_SwitchInspectionReportSchema.sections.map((section) => {
          return <ReportTableSectionRenderer section={section} rowsData={rowsData} />;
        })}
      </table>
    </div>
  );
};

export const TNW_SwitchInspectionReportViewV1 = (props) => {
  let { reportData, signatureImage } = props;
  let rowsData = reportData && reportData.assets && Array.isArray(reportData.assets) ? reportData.assets : [];
  let { isPreview } = props;
  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="DETAILED SWITCH INSPECTION REPORT" {...props} centerTitle={true} />
      <ReportInfoSection
        rows={[
          {
            col1: {
              title: "Location",
              value: reportData.location,
            },
            col2: {
              title: "Date",
              value: dataFormatters.dateFormatter(reportData.date),
            },
          },
          {
            col1: {
              title: "Track Inspector",
              value: reportData.user.name,
            },
            col2: {
              title: "Signature",
              value: <SignatureImage placement={"tableCell"} signatureImage={signatureImage} />,
            },
          },
        ]}
      />

      <span className="spacer"></span>
      <table className="table-bordered">
        {TNW_SwitchInspectionReportSchemaV1.sections.map((section) => {
          return <ReportTableSectionRenderer section={section} rowsData={rowsData} />;
        })}
      </table>
    </div>
  );
};

const TNW_SwitchInspectionReport = (props) => {
  const { inspec, isPreview } = props;
  if (isPreview) {
    return <ReportView reportData={{}} isPreview={true} />;
  }
  let reportVersion = ReportGeneratorUtils.getInspectionAppFormReportVersion(inspec, "tnwSwitchInspectionForm");
  const ReportView = reportByVersion(reportVersion, "tnwSwitchInspectionReport");
  return (
    <ReportView
      {...props}
      reportData={{
        assets: ReportGeneratorUtils.getInspectionAssetsWithForm(inspec, getAllowedSwitches, "tnwSwitchInspectionForm"),
        location: ReportGeneratorUtils.getInspectionLocation(inspec),
        date: ReportGeneratorUtils.getInspectionDate(inspec),
        user: ReportGeneratorUtils.getInspectionUser(inspec),
      }}
    />
  );
};

export default TNW_SwitchInspectionReport;

//inspec, getAllowedSwitches, "tnwSwitchInspectionForm"



// WEBPACK FOOTER //
// ./src/components/Reports/TNW/SwitchInspectionReport/index.jsx